/* product-swatch-mobile.js — hand-authored, NOT part of the webpack app.js bundle.
 *
 * Product-card swatch behaviour (desktop + mobile). Each swatch dot in
 * snippets/product-card.liquid ([data-swatch-bar]) may carry the first two
 * media images for its metal/colour as data-primary-* / data-hover-* attributes.
 * Clicking a dot:
 *   • selects it (adds .is-active → black border, styled in additional.css),
 *   • swaps the card's primary + hover images (.js-card-primary/.js-card-hover)
 *     to that metal WITHOUT navigating to the PDP,
 *   • on mobile, updates the inline selected-value label ([data-swatch-label]).
 *
 * Swatches WITHOUT image data (e.g. the custom.materials metafield fallback):
 *   • desktop — the click falls through to the card link (PDP), as before,
 *   • mobile — the click still just selects/labels (only the image/title open
 *     the PDP on mobile).
 *
 * A single capture-phase document listener also covers cards appended later by
 * "Load more" (Section Rendering API). Running in the capture phase and calling
 * stopPropagation keeps the tooltip module's document-level click handler from
 * firing on the tap and stops the card link from navigating.
 *
 * Loaded with `defer` after app.js so it shares the same DOM-ready timing.
 */
(function () {
  'use strict';

  document.addEventListener(
    'click',
    function (e) {
      var dot = e.target.closest && e.target.closest('[data-swatch-value]');
      if (!dot) return;

      var bar = dot.closest('[data-swatch-bar]');
      if (!bar) return;

      var hasImages = dot.hasAttribute('data-primary-src');

      // A swatch click always selects/swaps — it must never open the PDP (only the
      // card image/title/price do). Runs in the capture phase so preventDefault
      // beats the card link and stopPropagation beats the tooltip module.
      e.preventDefault();
      e.stopPropagation();

      // Selected state (black border via .swatch-dot.is-active).
      var dots = bar.querySelectorAll('[data-swatch-value]');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', dots[i] === dot);
      }

      // Mobile inline selected-value label.
      var label = bar.querySelector('[data-swatch-label]');
      if (label) label.textContent = dot.getAttribute('data-swatch-value') || '';

      if (!hasImages) return;

      // Swap the card imagery to the selected metal/colour.
      var card = bar.closest('a') || bar.parentNode;
      var media = card && card.querySelector('[data-card-media]');
      if (!media) return;

      var primaryImg = media.querySelector('.js-card-primary');
      var hoverImg = media.querySelector('.js-card-hover');

      var pSrc = dot.getAttribute('data-primary-src');
      var pSet = dot.getAttribute('data-primary-srcset');
      // Reuse the primary image when a metal has no distinct second image.
      var hSrc = dot.getAttribute('data-hover-src') || pSrc;
      var hSet = dot.getAttribute('data-hover-srcset') || pSet;

      if (primaryImg && pSrc) {
        primaryImg.srcset = pSet || '';
        primaryImg.src = pSrc;
      }
      if (hoverImg && hSrc) {
        hoverImg.srcset = hSet || '';
        hoverImg.src = hSrc;
      }
    },
    true
  );
})();
